import { Box, Image, Text, Button, VStack, HStack, Heading, Icon, Skeleton, Flex, Spinner } from '@chakra-ui/react';
import React, { useState } from 'react';
import Medico from '../../../../../../images/dashboard/consultorioMedico.png';
import Dentista from '../../../../../../images/dashboard/consultorioDentista.png';
import Exame from '../../../../../../images/dashboard/exame-laboratoria.svg';
import { useNavigate } from 'react-router-dom';
import useModelAtendimentoPresencial from './useModelAtendimentoPresencial';
import { IoMdCalendar } from 'react-icons/io';

export const AtendimentoPresencial = () => {
  const [imgLoaded, setImgLoaded] = useState({ medico1: false, medico2: false, dentista: false });
  const navigate = useNavigate();
  const { valores, error, loading } = useModelAtendimentoPresencial();
  console.log('valores atendimento presencial:', valores);
  return (
    <Flex w="100%" justify="center" mt={4} mb={2}>
      <Box border="1px solid #5AB2AE" borderRadius="1em" boxShadow="lg" p={2} w="96%" maxW="480px" bg="white">
        <VStack w="100%" spacing={2}>
          <Box
            borderRadius="20px"
            w="100%"
            bg="white"
            p={3}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            gap={4}
          >
            <HStack spacing={4} align="start" width="100%">
              <Box flexShrink={0} width="100px" height="100px" borderRadius="lg" overflow="hidden">
                <Skeleton isLoaded={imgLoaded.medico1}>
                  <Image
                    src={Medico}
                    alt="medico"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                    onLoad={() => setImgLoaded((prev) => ({ ...prev, medico1: true }))}
                  />
                </Skeleton>
              </Box>

              <VStack width="100%" align="flex-start" spacing={3}>
                <Box>
                  <Text fontSize="0.8rem" fontWeight="semibold" color="#9E9E9E" noOfLines={1}>
                    Atendimento
                  </Text>

                  <Heading
                    as="h3"
                    fontSize="1.1rem"
                    size={{ base: 'md', sm: 'lg' }}
                    color="#616161"
                    fontWeight="extrabold"
                    noOfLines={2}
                    lineHeight="1.1"
                    m={0}
                    p={0}
                  >
                    Consulta Presencial
                  </Heading>
                </Box>

                <HStack w="100%" justifyContent="space-between" alignItems="flex-end" mt={1}>
                  <VStack align="flex-start" spacing={1} lineHeight="1">
                    {valores.valor_consulta !== null && (
                      <Text fontSize="0.8rem" fontWeight="semibold" color="#9E9E9E">
                        a partir de
                      </Text>
                    )}

                    {valores.valor_consulta !== null && (
                      <HStack>
                        {loading ? (
                          <Spinner size="sm" color="#5AB2AE" thickness="3px" speed="0.7s" />
                        ) : (
                          <Text as="h3" fontSize="1.3rem" color={!error ? '#9E9E9E' : 'red'} fontWeight="semibold">
                            {Number(valores?.valor_consulta || 0).toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </Text>
                        )}
                      </HStack>
                    )}
                  </VStack>
                </HStack>
                {valores.valor_consulta === null && !loading && (
                  <Text fontSize="0.8em" width="full" color="#757575" fontWeight="semibold">
                    Sem agendas disponíveis
                  </Text>
                )}
              </VStack>
            </HStack>

            <Button
              disabled={valores.valor_consulta === null || loading}
              bg={valores.valor_consulta === null ? 'gray.300' : '#5AB2AE'}
              color="white"
              leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
              borderRadius="full"
              fontSize="xs"
              px={{ base: 4, sm: 5 }}
              py={3}
              w={{ base: '50%', sm: 'auto' }}
              onClick={() =>
                navigate('/medicosGeral', {
                  state: { typeList: 'Medicos' },
                })
              }
            >
              Agendar
            </Button>
          </Box>

          <Box
            borderRadius="20px"
            w="100%"
            bg="white"
            p={3}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            gap={4}
          >
            <HStack spacing={4} align="start" width="100%">
              <Box flexShrink={0} width="100px" height="100px" borderRadius="lg" overflow="hidden">
                <Skeleton isLoaded={imgLoaded.medico2}>
                  <Image
                    src={Exame}
                    alt="medico"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                    onLoad={() => setImgLoaded((prev) => ({ ...prev, medico2: true }))}
                  />
                </Skeleton>
              </Box>

              <VStack width="100%" align="flex-start" spacing={3}>
                <Box>
                  <Text fontSize="0.8rem" fontWeight="semibold" color="#9E9E9E" noOfLines={1}>
                    Diagnóstico
                  </Text>

                  <Heading
                    as="h3"
                    fontSize="1.1rem"
                    size={{ base: 'md', sm: 'lg' }}
                    color="#616161"
                    fontWeight="extrabold"
                    noOfLines={2}
                    lineHeight="1.1"
                    m={0}
                    p={0}
                  >
                    Exames
                  </Heading>
                </Box>

                <HStack w="100%" justifyContent="space-between" alignItems="flex-end" mt={1}>
                  <VStack align="flex-start" spacing={1} lineHeight="1">
                    {valores.valor_exames !== null && (
                      <Text fontSize="0.8rem" fontWeight="semibold" color="#9E9E9E">
                        a partir de
                      </Text>
                    )}

                    {valores.valor_exames !== null && (
                      <HStack>
                        {loading ? (
                          <Spinner size="sm" color="#5AB2AE" thickness="3px" speed="0.7s" />
                        ) : (
                          <Text as="h3" fontSize="1.3rem" color={!error ? '#9E9E9E' : 'red'} fontWeight="semibold">
                            {Number(valores?.valor_exames || 0).toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </Text>
                        )}
                      </HStack>
                    )}
                  </VStack>
                </HStack>
                {!valores.valor_exames && !loading && (
                  <Text fontSize="0.8em" width="full" color="#757575" fontWeight="semibold">
                    Sem agendas disponíveis
                  </Text>
                )}
              </VStack>
            </HStack>

            <Button
              disabled={valores.valor_exames === null || loading}
              bg={valores.valor_exames === null ? 'gray.300' : '#5AB2AE'}
              color="white"
              leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
              borderRadius="full"
              fontSize="xs"
              px={{ base: 4, sm: 5 }}
              py={3}
              w={{ base: '50%', sm: 'auto' }}
              onClick={() =>
                navigate('/exames/agendamento', {
                  state: { grupo_nome: 'Exames', grupo: 0 },
                })
              }
            >
              Agendar
            </Button>
          </Box>

          <Box
            borderRadius="20px"
            w="100%"
            bg="white"
            p={3}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            gap={4}
          >
            <HStack spacing={4} align="center" width="100%">
              <Box flexShrink={0} width="100px" height="100px" borderRadius="lg" overflow="hidden">
                <Skeleton isLoaded={imgLoaded.dentista}>
                  <Image
                    src={Dentista}
                    alt="dentista"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                    onLoad={() => setImgLoaded((prev) => ({ ...prev, dentista: true }))}
                  />
                </Skeleton>
              </Box>

              <VStack width="100%" align="flex-start" spacing={3}>
                <Box>
                  <Text fontSize="0.8rem" fontWeight="semibold" color="#9E9E9E" noOfLines={1}>
                    Odontologia
                  </Text>

                  <Heading
                    as="h3"
                    fontSize="1.1rem"
                    size={{ base: 'md', sm: 'lg' }}
                    color="#616161"
                    fontWeight="extrabold"
                    noOfLines={2}
                    lineHeight="1.1"
                    m={0}
                    p={0}
                  >
                    Consulta Odontológica
                  </Heading>
                </Box>

                <HStack w="100%" justifyContent="space-between" alignItems="flex-end" mt={1}>
                  <VStack align="flex-start" spacing={1} lineHeight="1">
                    {valores.valor_odonto !== null && (
                      <Text fontSize="0.8rem" fontWeight="semibold" color="#9E9E9E">
                        a partir de
                      </Text>
                    )}

                    {valores.valor_odonto !== null && (
                      <HStack>
                        {loading ? (
                          <Spinner size="sm" color="#5AB2AE" thickness="3px" speed="0.7s" />
                        ) : (
                          <Text as="h3" fontSize="1.3rem" color={!error ? '#9E9E9E' : 'red'} fontWeight="semibold">
                            {Number(valores?.valor_odonto || 0).toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </Text>
                        )}
                      </HStack>
                    )}
                  </VStack>
                </HStack>
                {!valores.valor_odonto && !loading && (
                  <Text fontSize="0.8em" width="full" color="#757575" fontWeight="semibold">
                    Sem agendas disponíveis
                  </Text>
                )}
              </VStack>
            </HStack>

            <Button
              disabled={valores.valor_odonto === null || loading}
              bg={valores.valor_odonto === null ? 'gray.300' : '#5AB2AE'}
              color="white"
              leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
              borderRadius="full"
              fontSize="xs"
              px={{ base: 4, sm: 5 }}
              py={3}
              w={{ base: '50%', sm: 'auto' }}
              onClick={() =>
                navigate('/medicosGeral', {
                  state: { typeList: 'Dentistas' },
                })
              }
            >
              Agendar
            </Button>
          </Box>
        </VStack>
      </Box>
    </Flex>
  );
};

export default AtendimentoPresencial;
